import { defineAsyncComponent, defineComponent } from 'vue'
import { BlockModule } from '../common'
import { wait } from '@/lib/promise'

new BlockModule({
    selector: '.block-accordion',
    vueComponent: defineComponent({
        name: 'block-accordion',
        components: {
            Accordion: defineAsyncComponent(
                () => import('@/components/ui/accordion/Accordion.vue')
            ),
            AccordionContent: defineAsyncComponent(
                () => import('radix-vue').then(x => x.AccordionContent)
            ),
            AccordionItem: defineAsyncComponent(
                () => import('radix-vue').then(x => x.AccordionItem)
            ),
            AccordionTrigger: defineAsyncComponent(
                () => import('radix-vue').then(x => x.AccordionTrigger)
            ),
            DialogTitle: defineAsyncComponent(
                () => import('@/components/ui/dialog/DialogTitle.vue')
            ),
            DialogDescription: defineAsyncComponent(
                () => import('@/components/ui/dialog/DialogDescription.vue')
            ),
            DialogContent: defineAsyncComponent(
                () => import('@/components/ui/dialog/DialogContent.vue')
            ),
            DialogRoot: defineAsyncComponent(
                () => import('@/components/ui/dialog/Dialog.vue')
            ),
            DialogTrigger: defineAsyncComponent(
                () => import('@/components/ui/dialog/DialogTrigger.vue')
            ),
            DialogClose: defineAsyncComponent(
                () => import('@/components/ui/dialog/DialogClose.vue')
            ),
        },
        setup() {
            const scrollToItem = (id: string) => {
                if (id) {
                    document.getElementById(id)?.scrollIntoView()
                }
            }

            const onAccordionMounted = async(id: string) => {
                await wait(1000, () => scrollToItem(id))
                window.dispatchEvent(new CustomEvent('blocks:reinit'))
            }

            return {
                onAccordionMounted
            }
        }
    })
})